import './Heading.scss';

export interface HeadingProps {
  /**
   * Heading level (h1-h6)
   */
  level: 1 | 2 | 3 | 4 | 5 | 6;
  /**
   * Visual variant
   */
  variant?: 'display' | 'title' | 'subtitle';
  /**
   * Content
   */
  children: React.ReactNode;
  /**
   * Additional class name
   */
  className?: string;
}

/**
 * Heading component (h1-h6) with design token typography
 */
export function Heading({ level, variant = 'title', children, className }: HeadingProps) {
  const Component = `h${level}` as keyof React.JSX.IntrinsicElements;
  const classes = ['heading', `heading-${variant}`, `heading-level-${level}`, className]
    .filter(Boolean)
    .join(' ');

  return <Component className={classes}>{children}</Component>;
}
